export const ANDROID = 'Android';
export const ANDROID_MOBILE = 'AndroidMobile';
export const BLACKBERRY = 'BlackBerry';
export const BLACKBERRY_MOBILE = 'BlackBerryMobile';
export const CHROME = 'Chrome';
export const CHROME_MOBILE = 'ChromeMobile';
export const EDGE = 'Edge';
export const EDGE_MOBILE = 'EdgeMobile';
export const FIREFOX = 'Firefox';
export const FIREFOX_MOBILE = 'FirefoxMobile';
export const MIUIBROWSER = 'MiuiBrowser';
export const MIUIBROWSER_MOBILE = 'MiuiBrowserMobile';
export const MSIE = 'MSIE';
export const MSIE_MOBILE = 'MSIEMobile';
export const OPERA = 'Opera';
export const OPERA_MOBILE = 'OperaMobile';
export const PUFFIN = 'Puffin';
export const PUFFIN_MOBILE = 'PuffinMobile';
export const SAFARI = 'Safari';
export const SAFARI_MOBILE = 'SafariMobile';
export const SAMSUNGBROWSER = 'SamsungBrowser';
export const SAMSUNGBROWSER_MOBILE = 'SamsungBrowserMobile';
export const UCBROWSER = 'UCBrowser';
export const UCBROWSER_MOBILE = 'UCBrowserMobile';
export const YABROWSER = 'YaBrowser';
export const YABROWSER_MOBILE = 'YaBrowserMobile';

/**
 * Searches provided userAgent for mobile string.
 * @param {string} userAgent user agent to search.
 * @returns {boolean} true if the user agent is mobile.
 */
export function hasMobile(userAgent = '') {
  return userAgent.search(/mobi/i) !== -1;
}

/**
 * Get the current browser user agent.
 * @returns {string} the user agent found, or an empty string.
 */
export function getUserAgent() {
  const ua = window.navigator.userAgent;
  return ua ? ua : '';
}

/**
 * Get browser name
 * @returns {string} The browser name, appends 'Mobile' when mobile found
 */
const getBrowserName = () => {
  const userAgent = getUserAgent();
  let browserName = 'unknown';

  if (userAgent.search(/(?=^.*opera|opr)/i) !== -1) {
    browserName = OPERA;
  } else if (
    userAgent.search(
      /(?=^.*chrome)(?!^.*ucbrowser|ucweb)(?!^.*mi\sa1)(?!^.*yabrowser)(?!^.*samsungbrowser)(?!^.*edge)(?!^.*puffin).*/i
    ) !== -1
  ) {
    browserName = CHROME;
  } else if (
    userAgent.search(
      /(?=^.*android)(?!^.*puffin)(?!^.*edge)(?!^.*mi\sa1)(?!^.*yabrowser)(?!^.*samsungbrowser)(?!^.*ucbrowser)(?!^.*firefox)/i
    ) !== -1
  ) {
    browserName = ANDROID;
  } else if (
    userAgent.search(
      // eslint-disable-next-line max-len
      /(?=^.*safari)(?!^.*ucbrowser|ucweb)(?!^.*mi\sa1)(?!^.*bb\d\d)(?!^.*blackberry)(?!^.*yabrowser)(?!^.*edge)(?!^.*samsungbrowser)(?!^.*puffin)(?!^.*blackberry)(?!^.*firefox)(?!^.*fxios).*/i
    ) !== -1
  ) {
    browserName = SAFARI;
  } else if (userAgent.search(/(?=^.*firefox|fxios)(?!^.*puffin).*/i) !== -1) {
    browserName = FIREFOX;
  } else if (userAgent.search(/(?=^.*ucbrowser|ucweb)/i) !== -1) {
    browserName = UCBROWSER;
  } else if (userAgent.search(/(?=^.*msie|trident)/i) !== -1) {
    browserName = MSIE;
  } else if (userAgent.search(/(?=^.*puffin)/i) !== -1) {
    browserName = PUFFIN;
  } else if (userAgent.search(/(?=^.*samsungbrowser)/i) !== -1) {
    browserName = SAMSUNGBROWSER;
  } else if (userAgent.search(/(?=^.*yabrowser)/i) !== -1) {
    browserName = YABROWSER;
  } else if (userAgent.search(/(?=^.*mi\sa1)/i) !== -1) {
    browserName = MIUIBROWSER;
  } else if (userAgent.search(/(?=^.*edge)/i) !== -1) {
    browserName = EDGE;
  } else if (userAgent.search(/(?=^.*blackberry|bb\d\d)/i) !== -1) {
    browserName = BLACKBERRY;
  }

  // append mobile when found.
  if (hasMobile(userAgent)) {
    browserName += 'Mobile';
  }
  return browserName;
};

export default getBrowserName;
